import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { REACT_APP_API_URL } from '../../../env';
import EmployeeViewEditModal from '../AllEmployees/Components/EmployeeViewEditModal';
import axios from 'axios';

const EmployeeProfile = () => {
  const { hrmsUser, userType } = useSelector((state) => state.auth);
  const navigate = useNavigate();


  const [employeeData, setEmployeeData] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (userType !== 'hrms') {
      navigate('/hrms/login');
    }
  }, [userType, navigate]);

  useEffect(() => {
    if (userType === 'hrms' && hrmsUser) {
      fetchFullEmployee();
    }
  }, [userType, hrmsUser]);

  const fetchFullEmployee = async () => {
    try {
      const res = await axios.get(`${REACT_APP_API_URL}api/hrms/get-employee/${hrmsUser.id}`, {
        withCredentials: true,
      });
      // console.log("Fetched employee:", res.data);
      setEmployeeData(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const openModal = (mode = "view") => {
    setEditMode(mode === "edit");
    setShowModal(true);
  };

  const imageSrc =
    employeeData?.vchUserImage &&
      employeeData.vchUserImage.trim() !== ""
      ? `${REACT_APP_API_URL}${employeeData.vchUserImage.replace(/\\/g, "/")}`
      : "/images/avatar.png";

  if (loading) return <div className="text-center p-5">Loading...</div>;
  if (!employeeData) return <div>No employee data found</div>;

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-header d-flex justify-content-between align-items-center">
              <h4 className="card-title">My Profile</h4>
              <button
                className="btn btn-sm btn-outline-warning"
                onClick={() => openModal("edit")}
              >
                Edit Profile
              </button>
            </div>

            <div className="card-body">
              <div className="row">
                <div className="col-md-4 text-center">
                  <img
                    src={imageSrc}
                    alt={employeeData.vchFullName}
                    className="rounded-circle border mb-3"
                    width="120"
                    height="120"
                    style={{ objectFit: 'cover' }}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = '/images/avatar.png';
                    }}
                  />
                  <h5>{employeeData.vchFullName}</h5>
                  <p className="text-muted mb-0">{employeeData.vchDesignation}</p>
                </div>

                <div className="col-md-8">
                  <div className="row">
                    <div className="col-sm-6 mb-3">
                      <label className="form-label fw-bold">Employee ID</label>
                      <p className="form-control-plaintext">{employeeData.vchEmpCode}</p>
                    </div>
                    <div className="col-sm-6 mb-3">
                      <label className="form-label fw-bold">Full Name</label>
                      <p className="form-control-plaintext">{employeeData.vchFullName}</p>
                    </div>
                    <div className="col-sm-6 mb-3">
                      <label className="form-label fw-bold">Email</label>
                      <p className="form-control-plaintext">{employeeData.vchEmail}</p>
                    </div>
                    <div className="col-sm-6 mb-3">
                      <label className="form-label fw-bold">Phone</label>
                      <p className="form-control-plaintext">{employeeData.vchMobTel}</p>
                    </div>
                    <div className="col-sm-6 mb-3">
                      <label className="form-label fw-bold">Gender</label>
                      <p className="form-control-plaintext">{employeeData.vchGender}</p>
                    </div>
                    <div className="col-sm-6 mb-3">
                      <label className="form-label fw-bold">Address</label>
                      <p className="form-control-plaintext">{employeeData.vchPreAddress}</p>
                    </div>
                    <div className="col-sm-6 mb-3">
                      <label className="form-label fw-bold">Department/Unit</label>
                      <p className="form-control-plaintext">{employeeData.vchDepartment}</p>
                    </div>
                    <div className="col-sm-6 mb-3">
                      <label className="form-label fw-bold">Company</label>
                      <p className="form-control-plaintext">{employeeData.vchCompanyName}</p>
                    </div>
                    <div className="col-sm-6 mb-3">
                      <label className="form-label fw-bold">Date of Birth</label>
                      <p className="form-control-plaintext">{employeeData.dtmDob?.split("T")[0]}</p>
                    </div>
                    <div className="col-sm-6 mb-3">
                      <label className="form-label fw-bold">Date of Joining</label>
                      <p className="form-control-plaintext">{employeeData.dtmDoj?.split("T")[0]}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal for View/Edit */}
      {showModal && (
        <EmployeeViewEditModal
          show={showModal}
          onClose={() => setShowModal(false)}
          employee={employeeData}
          editMode={editMode}
          setEditMode={setEditMode}
          onSuccess={(updatedEmployee) => {
            if (updatedEmployee) {

              setEmployeeData({
                ...updatedEmployee,
                dtmDob: updatedEmployee.dtmDob ? new Date(updatedEmployee.dtmDob).toISOString() : null,
                dtmDoj: updatedEmployee.dtmDoj ? new Date(updatedEmployee.dtmDoj).toISOString() : null,
              });
            } else {
              fetchFullEmployee();
            }
          }}
        />
      )}
    </div>
  );
};

export default EmployeeProfile;
